import { useState } from "react";

const useOpenLogoutOptions = () => {
    const [openLogoutOptions, setOpenLogoutOptions] = useState();
    return {
        value: openLogoutOptions,
        set: setOpenLogoutOptions
    };
}

export default useOpenLogoutOptions;